import React from 'react';
import { Typography } from '@mui/material';

export const MoreProfilesLine: React.FC = () => (
  <Typography variant="body2" color="text.secondary" px={2} pb={2}>
    Want to see more profiles, or ones like these? Reach out to your AgileEngine
    team.
  </Typography>
);
